function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#043B74",
  fillRule: "nonzero",
  d: "M.466 10.793a7.313 7.313 0 0 1 .246-2.904c.884-3.014 3.655-5.23 6.942-5.269V.65c0-.11.137-.168.226-.101l4.054 2.978c.066.05.066.152 0 .2l-4.05 2.977c-.093.067-.226.008-.226-.101V4.637a5.306 5.306 0 0 0-4.8 3.252 5.235 5.235 0 0 0 .747 5.343c.36.45.273 1.106-.192 1.446a1.017 1.017 0 0 1-1.4-.196 7.227 7.227 0 0 1-1.547-3.69zm11.702-3.784a5.22 5.22 0 0 1 1.157 3.022 5.27 5.27 0 0 1-.41 2.321c-.794 1.884-2.639 3.22-4.8 3.252v-1.966c0-.11-.137-.168-.227-.101l-4.053 2.978c-.066.05-.066.152 0 .2l4.05 2.977c.093.067.226.008.226-.101v-1.97c3.287-.035 6.062-2.251 6.942-5.269.265-.907.36-1.888.246-2.904a7.19 7.19 0 0 0-1.544-3.69 1.017 1.017 0 0 0-1.4-.195c-.46.34-.547.997-.187 1.446z"
});

const SvgRefresh = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRefresh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/refresh.9c59e987.svg";
export { ForwardRef as ReactComponent };